<template>
<section class="premium-section">
<h2 class="section-title">Creator Reward Allocation and Ecosystem Utilization</h2>

<p>
Within the Mudra tokenomics structure, up to sixty percent of the total token supply has been allocated for creator rewards.
</p>

<p>
This allocation represents the maximum amount of MDR tokens that may be distributed to creators through the reward system.
</p>

<p>
However, only tokens corresponding to rewards actually earned by creators will be allocated during the reward snapshot process.
</p>

<p>
Any undistributed tokens from the creator reward allocation may later support ecosystem development, platform improvements, partnerships, and community initiatives.
</p>

<p>
This approach ensures that token distribution remains aligned with the long-term sustainability of the Mudra ecosystem.
</p>

</section>
</template>